import RecordTemplate     from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateName from "../../../../domain/record/template/RecordTemplateName";
import WidgetItem         from "../../../../domain/record/widget/item/WidgetItem";
import WidgetItemTitle    from "../../../../domain/record/widget/item/WidgetItemTitle";
import Widget             from "../../../../domain/record/widget/Widget";
import WidgetTitle        from "../../../../domain/record/widget/WidgetTitle";
import ResKaReduxAction   from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_RECORD_TEMPLATE = "SET_RECORD_TEMPLATE",
  SET_RECORD_TEMPLATE_NAME = "SET_RECORD_TEMPLATE_NAME",
  ADD_RECORD_TEMPLATE_WIDGET = "ADD_RECORD_TEMPLATE_WIDGET",
  DELETE_RECORD_TEMPLATE_WIDGET = "DELETE_RECORD_TEMPLATE_WIDGET",
  MOVE_RECORD_TEMPLATE_WIDGET = "MOVE_RECORD_TEMPLATE_WIDGET",
  ADD_RECORD_TEMPLATE_WIDGET_ITEM = "ADD_RECORD_TEMPLATE_WIDGET_ITEM",
  DELETE_RECORD_TEMPLATE_WIDGET_ITEM = "DELETE_RECORD_TEMPLATE_WIDGET_ITEM",
  SET_RECORD_TEMPLATE_WIDGET_TITLE = "SET_RECORD_TEMPLATE_WIDGET_TITLE",
  SET_RECORD_TEMPLATE_WIDGET_ITEM_TITLE = "SET_RECORD_TEMPLATE_WIDGET_ITEM_TITLE",
}

export interface SetRecordTemplateAction extends ResKaReduxAction {
  template: RecordTemplate;
}

export interface SetRecordTemplateNameAction extends ResKaReduxAction {
  name: RecordTemplateName;
}

export interface AddRecordTemplateWidgetAction extends ResKaReduxAction {
  widget: Widget;
}

export interface DeleteRecordTemplateWidgetAction extends ResKaReduxAction {
  widgetIndex: number;
}

export interface MoveRecordTemplateWidgetAction extends ResKaReduxAction {
  widgetIndex: number;
  widget: Widget;
}

export interface AddRecordTemplateWidgetItemAction extends ResKaReduxAction {
  widgetIndex: number;
  widgetItem: WidgetItem;
}

export interface DeleteRecordTemplateWidgetItemAction extends ResKaReduxAction {
  widgetIndex: number;
  widgetItemIndex: number;
}

export interface SetRecordTemplateWidgetTitleAction extends ResKaReduxAction {
  widgetIndex: number;
  widgetTitle: WidgetTitle;
}

export interface SetRecordTemplateWidgetItemTitleAction extends ResKaReduxAction {
  widgetIndex: number;
  widgetItemIndex: number;
  widgetItemTitle: WidgetItemTitle;
}

export type RecordTemplateAction =
  SetRecordTemplateAction
  | SetRecordTemplateNameAction
  | AddRecordTemplateWidgetAction
  | DeleteRecordTemplateWidgetAction
  | MoveRecordTemplateWidgetAction
  | AddRecordTemplateWidgetItemAction
  | DeleteRecordTemplateWidgetItemAction
  | SetRecordTemplateWidgetTitleAction
  | SetRecordTemplateWidgetItemTitleAction
  ;

export const setRecordTemplateAction = (template: RecordTemplate): SetRecordTemplateAction => ({
  type: ACTION_TYPE.SET_RECORD_TEMPLATE,
  template: template,
});

export const setRecordTemplateNameAction = (name: RecordTemplateName): SetRecordTemplateNameAction => ({
  type: ACTION_TYPE.SET_RECORD_TEMPLATE_NAME,
  name: name,
});

export const addRecordTemplateWidgetAction = (widget: Widget): AddRecordTemplateWidgetAction => ({
  type: ACTION_TYPE.ADD_RECORD_TEMPLATE_WIDGET,
  widget: widget,
});

export const deleteRecordTemplateWidgetAction = (widgetIndex: number): DeleteRecordTemplateWidgetAction => ({
  type: ACTION_TYPE.DELETE_RECORD_TEMPLATE_WIDGET,
  widgetIndex: widgetIndex,
});

export const moveRecordTemplateWidgetAction = (widgetIndex: number, widget: Widget): MoveRecordTemplateWidgetAction => ({
  type: ACTION_TYPE.MOVE_RECORD_TEMPLATE_WIDGET,
  widgetIndex: widgetIndex,
  widget: widget,
});

export const addRecordTemplateWidgetItemAction = (widgetIndex: number, widgetItem: WidgetItem): AddRecordTemplateWidgetItemAction => ({
  type: ACTION_TYPE.ADD_RECORD_TEMPLATE_WIDGET_ITEM,
  widgetIndex: widgetIndex,
  widgetItem: widgetItem,
});

export const deleteRecordTemplateWidgetItemAction = (widgetIndex: number, widgetItemIndex: number): DeleteRecordTemplateWidgetItemAction => ({
  type: ACTION_TYPE.DELETE_RECORD_TEMPLATE_WIDGET_ITEM,
  widgetIndex: widgetIndex,
  widgetItemIndex: widgetItemIndex,
});

export const setRecordTemplateWidgetTitleAction = (widgetIndex: number, widgetTitle: WidgetTitle): SetRecordTemplateWidgetTitleAction => ({
  type: ACTION_TYPE.SET_RECORD_TEMPLATE_WIDGET_TITLE,
  widgetIndex: widgetIndex,
  widgetTitle: widgetTitle,
});

export const setRecordTemplateWidgetItemTitleAction = (widgetIndex: number, widgetItemIndex: number, widgetItemTitle: WidgetItemTitle): SetRecordTemplateWidgetItemTitleAction => ({
  type: ACTION_TYPE.SET_RECORD_TEMPLATE_WIDGET_ITEM_TITLE,
  widgetIndex: widgetIndex,
  widgetItemIndex: widgetItemIndex,
  widgetItemTitle: widgetItemTitle,
});